export const PREMIUM = "PREMIUM";
export const NORMAL = "NORMAL";
export const BAEMIN = "baemin";
export const YOGIYO = "yogiyo";
export const COUPANG = "coupang";
export const COUPANGEATS = "coupangeats";
